module.exports = __webpack_public_path__ + "908e4d2e/img/trash-icon.ff8201c7.svg";